<template>
	<div class="infoWrap">
		<div class="addAddress">
			<transition name="fade">
				<div v-if="addingAddressToAddressBookLoading" class="loadingOverlay"></div>
			</transition>

			<h3 v-if="editedAddress.active">{{'components/settings/address-book.add.edit-address' | trans}}</h3>
			<h3 v-else>{{'components/settings/address-book.add.add-new-address' | trans}}</h3>

			<div class="inputWrap">
				<input
					ref="autocomplete"
					:placeholder="'components/settings/address-book.add.search-new-address' | trans"
					type="text"
				/>
			</div>

			<Input
				:label="'components/settings/address-book.add.house-name' | trans"
				id="house"
				v-model="address.house"
			/>
			<Input
				:label="'components/settings/address-book.add.street' | trans"
				id="street"
				v-model="address.street"
				:v="$v.address.street"
			/>
			<div class="inputTwoCols">
				<Input
					:label="'components/settings/address-book.add.floor' | trans"
					id="floor"
					v-model="address.floor"
				/>
				<Input
					:label="'components/settings/address-book.add.apartment' | trans"
					id="apartment"
					v-model="address.apartment"
				/>
			</div>
			<Input
				:label="'components/settings/address-book.add.city' | trans"
				id="city"
				v-model="address.city"
				:v="$v.address.city"
			/>
			<Input
				:label="'components/settings/address-book.add.county' | trans"
				id="county"
				v-model="address.county"
			/>
			<Input
				:label="'components/settings/address-book.add.postal-code' | trans"
				id="postcode"
				v-model="address.postcode"
				:v="$v.address.postcode"
			/>

			<div class="selectWrap">
				<label>{{'components/settings/address-book.add.county' | trans}}</label>
				<v-select
					:options="computedCountries"
					v-model="address.country"
					:reduce="country => country.value"
					inputId="country"
					label="label"
				/>
			</div>


			<PulseLoader v-if="addingAddressToAddressBookLoading" size="8px" color="#00B2FF"/>
			<div v-else class="inputWrap">
				<button v-if="!editedAddress.active" @click="addAddress" class="btn btn-block">
					{{'components/settings/address-book.add.add-address' | trans}}
				</button>

				<div v-if="editedAddress.active" class="inputTwoCols">

					<button @click="saveEditedAddress" class="btn btn-block">
						{{'components/settings/address-book.add.edit-address' | trans}}
					</button>
					<button @click="cancelEditedAddress" class="btn btn-block">
						{{'components/settings/address-book.add.cancel' | trans}}
					</button>
				</div>
			</div>

		</div>

		<div class="addressList">

			<div class="addresses">
				<h3>{{'components/settings/address-book.list.my-addresses' | trans}}</h3>
				<div
					class="address"
					:key="index"
					v-for="({ house, street, city, county, country,country_name, postcode, floor, apartment, id, groupLabel, loading = false }, index) in addressBookGrouped"
				>
					<h2>{{ getAddressGroupLabel(groupLabel) }}</h2>
					<div>

						<div>{{ house }} {{ street }}</div>
						<div>
							<span
								v-if="floor"> {{'components/settings/address-book.list.floor' | trans}}: {{ floor }}</span>
							<span v-if="apartment"> {{'components/settings/address-book.list.apartment' | trans}}: {{ apartment }}</span>
						</div>
						<div>{{ city }}</div>
						<div>{{ county }}</div>
						<div>{{ country_name }}</div>
						<div>{{ postcode }}</div>

						<PulseLoader v-if="loading" size="8px" color="#00B2FF"/>

						<div v-else class="buttonsWrap">
							<button @click="editAddress(id)" class="btn btnThin btnSmall">{{'components/settings/address-book.list.button.edit' | trans}}</button>
							<button v-if="groupLabel=='Other'" @click="deleteAddressMethod(id)"
									class="btn btnDanger btnThin btnSmall">
								Delete
							</button>
						</div>
					</div>
				</div>
			</div>
			<PulseLoader v-if="addressBookLoading" size="8px" color="#00B2FF"/>
		</div>

	</div>

</template>

<script>
    import Input from '../form/Input';
    import {required} from 'vuelidate/lib/validators';
    import {mapState, mapActions} from 'vuex';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    // import vSelect1 from 'vue-select';
    import vSelect from '../temp/MyVueSelect';


    export default {
        data() {
            return {
                addressList: [],
                address: {
                    house: '',
                    street: '',
                    floor: '',
                    apartment: '',
                    city: '',
                    county: '',
                    postcode: '',
                    country: ''
                },
                editedAddress: {
                    active: false,
                    index: null
                },
                addingAddressToAddressBookLoading: false,
                selectedCountry: null,
            }
        },
        validations: {
            address: {
                street: {
                    required
                },
                city: {
                    required
                },
                postcode: {
                    required
                }
            },
        },
        components: {Input, PulseLoader, vSelect},
        mounted() {
            if(window['GSessionID'] === void(0)){
              window['GSessionID'] = Math.random().toString(36).replace(/[^0-9a-z]/gi,'X');
            }

            this.autocomplete = new google.maps.places.Autocomplete(
                (this.$refs.autocomplete),
                {
                    types: ['geocode'],
                    componentRestrictions: {country: 'GB'},
                    fields: ['address_components'],
                    sessionToken: window['GSessionID']
                }
            );

            this.autocomplete.addListener('place_changed', () => {
                this.clearAddressFields();
                let place = this.autocomplete.getPlace();
                let tmp = {};
                let data = this.address;
                const handler = (a, b) => {
                    if (data[a] === '' && (!b || (b && tmp['short_name']))) {
                        data[a] = b ? tmp['short_name'] : (tmp['long_name'] ? tmp['long_name'] : tmp['short_name']);

                        if (data[a] === void (0)) {
                            data[a] = '';
                        }
                    }
                };

                for (let i in place.address_components) {
                    tmp = place.address_components[i];

                    if (tmp.types.indexOf('street_number') >= 0) {
                        handler('house');
                    } else if (tmp.types.indexOf('postal_code') >= 0) {
                        handler('postcode');
                    } else if (tmp.types.indexOf('floor') >= 0) {
                        handler('floor');
                    } else if (tmp.types.indexOf('route') >= 0) {
                        handler('street');
                    } else if (tmp.types.indexOf('postal_town') >= 0 || tmp.types.indexOf('locality') >= 0) {
                        handler('city');
                    } else if (tmp.types.indexOf('administrative_area_level_2') >= 0 || tmp.types.indexOf('sublocality_level_1') >= 0) {
                        handler('county');
                    } else if (tmp.types.indexOf('country') >= 0) {
                        handler('country', true);
                    }
                }

                window['GSessionID'] = Math.random().toString(36).replace(/[^0-9a-z]/gi,'X');
            });
            this.getAddresses().then(r => {
            }).catch(e => {
                console.log('err8', r);
            });
        },
        methods: {
            ...mapActions(['addNewAddress', 'getAddresses', 'deleteAddress', 'updateAddress', 'getUserInfo', 'addMessage']),
            clearAddressFields: function () {
                this.address.floor = '';
                this.address.house = '';
                this.address.street = '';
                this.address.city = '';
                this.address.county = '';
                this.address.postcode = '';
                this.address.country = '';
            },
            addAddress: function () {
                this.$v.$touch();
                if (this.$v.$pending || this.$v.$error) return;
                this.$v.$reset();
                this.addingAddressToAddressBookLoading = true;
                this.addNewAddress(this.address)
                    .then(response => this.getAddresses().then(r => response))
                    .then(response => {
                        this.addMessage(response.data.messages);
                        this.addingAddressToAddressBookLoading = false;
                        this.$refs.autocomplete.value = '';
                        this.clearAddressFields();
                    })
                    .catch(error => {
                        this.addingAddressToAddressBookLoading = false;
                    });
            },
            editAddress: function (id) {
                this.$v.$reset();
                this.editedAddress.active = true;

                let addressToEdit = {};

                this.addressBook.forEach(function (address) {

                    if (address.id && address.id === id) {
                        addressToEdit = address;
                        addressToEdit.country = addressToEdit.country.toUpperCase();
                    }
                });

                this.address = {...addressToEdit};

                if (this.$mq === 'sm') {
                    $("html, body").animate({scrollTop: $(document).height()}, 400);
                }
            },
            saveEditedAddress: function () {
                let newAddress = {...this.address};
                this.editedAddress.active = false;

                this.addingAddressToAddressBookLoading = true;

                this.updateAddress({
                    floor: newAddress.floor,
                    apartment: newAddress.apartment,
                    house: newAddress.house,
                    street: newAddress.street,
                    city: newAddress.city,
                    county: newAddress.county,
                    postcode: newAddress.postcode,
                    country: newAddress.country,
                    addressId: newAddress.id
                })
                    .then(response => this.getUserInfo().then(r => response))
                    .then(response => this.getAddresses().then(r => response))
                    .then(response => {
                        this.addMessage(response.data.messages);
                        this.addingAddressToAddressBookLoading = false;
                        this.clearAddressFields();
                    })
                    .catch(err => {
                        console.log('err0', err)
                        this.addingAddressToAddressBookLoading = false;
                    });
            },
            cancelEditedAddress: function () {
                this.clearAddressFields();
                this.editedAddress.active = false;
                this.$v.$reset();
            },
            deleteAddressMethod: function (addressId) {
                this.deleteAddress(addressId)
                    .then(response => this.getAddresses().then(r => response))
                    .then(response => {
                        this.addMessage(response.data.messages)
                    })
                    .catch(err => console.log(err));
            },
            getAddressGroupLabel(labelVar) {
                if (labelVar === 'Other') {
                    return '';
                }
                return labelVar;
            }
        },
        computed: {
            ...mapState(['addressBook', 'addressBookLoading', 'user', 'countries']),
            computedCountries: function () {

                let returnData = [];
                for (let countryCode in this.countries) {
                    returnData.push({
                        value: countryCode,
                        label: this.countries[countryCode]
                    });
                }
                return returnData;
            },
            addressBookGrouped: function () {
                let groupedAddressBook = [];

                this.addressBook.forEach((address) => {
                    if (this.user.addresses.residentialAddressId == address.id) {
                        groupedAddressBook.push({
                            ...address,
                            groupType: 'home',
                            groupLabel: lang.get('components/settings/address-book.list.used-for-home-address')
                        });
                    }
                });

                if (this.user.cards) {
                    this.user.cards.forEach((card) => {
                        this.addressBook.forEach(function (address) {
                            if (card.address.address_id == address.id) {
                                groupedAddressBook.push({
                                    ...address,
                                    groupType: 'card',
                                    groupLabel: lang.get('components/settings/address-book.list.used-for-card', {card: card.pan})
                                });
                            }
                        });
                    });
                }

                this.addressBook.forEach((address) => {

                    let addressIsUsed = false;

                    groupedAddressBook.forEach(groupedAddress => {
                        if (groupedAddress.id == address.id) {
                            addressIsUsed = true;
                        }
                    });

                    if (!addressIsUsed) {
                        groupedAddressBook.push({
                            ...address,
                            groupType: 'other',
                            groupLabel: lang.get('components/settings/address-book.list.other')
                        });
                    }
                });

                return groupedAddressBook;
            }
        }
    }
</script>